// removed by extract-text-webpack-plugin
module.exports = {"hero":"styles__hero___36Mq-","heroPhoto":"styles__heroPhoto___11UU0","heroGallery":"styles__heroGallery___1VqME","heroGalleryPhoto":"styles__heroGalleryPhoto___bFbI0","heroGalleryButton":"styles__heroGalleryButton___2Bv0-","heroGalleryButtonIcon":"styles__heroGalleryButtonIcon___2JIgg"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/hero/styles.css
// module id = RoZr
// module chunks = 2